import { Button } from "@/components/ui/button";
import { InputFormik } from "@/components/ui/input-formik";
import { Label } from "@/components/ui/label";
import { useToast } from "@/components/ui/use-toast";
import { RequestAlterarSenha } from "@/dtos/Request/RequestAlterarSenha";
import AcessoService from "@/services/AcessoService";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as Yup from 'yup';

export default function EsqueciMinhaSenhaPage() {
    const navigate = useNavigate();
    const { toast } = useToast();
    let [searchParams] = useSearchParams();
    const [token, setToken] = useState('');

    useEffect(() => {
        const searchParamsToken = searchParams.get('token')

        if (searchParamsToken !== null) {
            setToken(searchParamsToken);
        }
    }, [])

    const formikAlterarSenha = useFormik<RequestAlterarSenha>({
        initialValues: {
            OldPassword: '',
            NewPassword: '',
            ConfirmPassword: ''
        },
        validationSchema: Yup.object({
            NewPassword: Yup.string()
                .min(5, 'Deve possuir ao menos 5 caracteres')
                .required('Obrigatório'),
            ConfirmPassword: Yup.string()
                .min(5, 'Deve possuir ao menos 5 caracteres')
                .required('Obrigatório')
                .test('Validar Confirmar Senha', 'Digite as duas senhas iguais', passwordToValidate => {
                    if (passwordToValidate !== formikAlterarSenha.values.NewPassword) {
                        return false;
                    }

                    return true;
                })
        }),
        onSubmit: async (values) => {
            try {
                const { Message } = await AcessoService.redefinirSenha(values.NewPassword, token);
                toast({
                    variant: 'success',
                    description: Message,
                    duration: 5000
                })

                navigate('/Acessar')
            } catch (error: any) {
                toast({
                    variant: 'destructive',
                    description: error,
                    duration: 4000
                });
            }
        }
    });

    const formikEsqueciMinhaSenha = useFormik({
        initialValues: {
            Login: ''
        },
        validationSchema: Yup.object({
            Login: Yup.string()
                .required('Obrigatório'),
        }),
        onSubmit: async (values) => {
            try {
                const { Message } = await AcessoService.esqueciMinhaSenha(values.Login)
                toast({
                    variant: 'success',
                    description: Message,
                    duration: 3000
                })
            } catch (error: any) {
                toast({
                    variant: 'destructive',
                    description: error,
                    duration: 4000
                });
            }

        }
    })


    return (
        !token ? (
            <>
                <form onSubmit={formikEsqueciMinhaSenha.handleSubmit} className="flex flex-col gap-4 mx-2 my-5">
                    <h1 className="text-primary-foreground text-2xl uppercase font-black">Esqueci minha Senha</h1>
                    <div className="flex flex-col">
                        <div className="w-full md:w-6/12">
                            <div className="flex flex-col gap-2 mt-3">
                                <Label htmlFor="novaSenha">E-mail ou CPF</Label>
                                <InputFormik
                                    placeholder="Digite seu login"
                                    type="text"
                                    id="Login"
                                    required
                                    formik={formikEsqueciMinhaSenha}
                                    name='Login'
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-end gap-3">
                        <Button type="submit" disabled={formikEsqueciMinhaSenha.isSubmitting || !formikEsqueciMinhaSenha.isValid} className="w-40">
                            {
                                formikEsqueciMinhaSenha.isSubmitting ? 'Aguarde...' : 'Confirmar'
                            }
                        </Button>
                    </div>
                </form>
            </>
        ) : (
            <>
                <form onSubmit={formikAlterarSenha.handleSubmit} className="flex flex-col gap-4 mx-2 my-5">
                    <h1 className="text-primary-foreground text-2xl uppercase font-black">Redefinir Senha</h1>
                    <div className="flex flex-col">
                        <div className="w-full md:w-6/12">
                            <div className="flex flex-col gap-2 mt-3">
                                <Label htmlFor="novaSenha">Senha</Label>
                                <InputFormik
                                    placeholder="Digite uma nova Senha"
                                    type="password"
                                    id="NewPassword"
                                    required
                                    formik={formikAlterarSenha}
                                    name='NewPassword'
                                />
                            </div>
                            <div className="flex flex-col gap-2 mt-3">
                                <Label htmlFor="confirmPassword">Confirmar Senha</Label>
                                <InputFormik
                                    placeholder="Digite sua nova senha novamente"
                                    type="password"
                                    id="ConfirmPassword"
                                    required
                                    formik={formikAlterarSenha}
                                    name='ConfirmPassword'
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-end gap-3">
                        <Button type="submit" disabled={formikAlterarSenha.isSubmitting || !formikAlterarSenha.isValid} className="w-40">
                            {
                                formikAlterarSenha.isSubmitting ? 'Alterando...' : 'Alterar'
                            }
                        </Button>
                    </div>
                </form>
            </>
        )
    )
}